import React from 'react';

import { Button, Grid, Typography } from '@mui/material';

import { SxProp } from 'src/types/mui';

interface SuccessContentProps {
  onCloseModal: () => void;
}

export const SuccessContent: React.FC<SuccessContentProps> = ({ onCloseModal }) => {
  return (
    <Grid container>
      <Grid mb={1} size={12}>
        <Typography variant="h2" sx={titleStyles}>
          Password successfully changed
        </Typography>
      </Grid>
      <Grid mb={4} sx={subtitleStyles} size={12}>
        <Typography variant="body2" color="text.secondary">
          You will be now redirected to the log in page
        </Typography>
      </Grid>
      <Grid container justifyContent="center" size={12}>
        <Button variant="contained" type="submit" onClick={onCloseModal}>
          Great!
        </Button>
      </Grid>
    </Grid>
  );
};

const titleStyles: SxProp = {
  fontSize: '24px',
};

const subtitleStyles: SxProp = theme => ({
  fontSize: '16px',
  color: theme.palette.grey['800'],
});
